const dev = {
	API_ENDPOINT_URL: process.env.REACT_APP_API_URL || 'http://localhost:1337',
	API_CLIENT_URL: process.env.REACT_APP_API_CLIENT_PATH || '/api',
	DEFAULT_USERS_PASSWORD:
		process.env.REACT_APP_DEFAULT_USERS_PASSWORD || 'FEbXS!EB=2Z+EPr#',
};

const prod = {
	API_ENDPOINT_URL:
		process.env.REACT_APP_API_URL || 'http://alpha.printxy.cc:1339',
	API_CLIENT_URL: process.env.REACT_APP_API_CLIENT_PATH || '/api',
	DEFAULT_USERS_PASSWORD:
		process.env.REACT_APP_DEFAULT_USERS_PASSWORD || 'FEbXS!EB=2Z+EPr#',
};

const test = {
	API_ENDPOINT_URL: process.env.REACT_APP_API_URL || 'http://localhost:1337',
	API_CLIENT_URL: process.env.REACT_APP_API_CLIENT_PATH || '/api',
	DEFAULT_USERS_PASSWORD:
		process.env.REACT_APP_DEFAULT_USERS_PASSWORD || 'FEbXS!EB=2Z+EPr#',
};

const getEnv = () => {
	switch (process.env.REACT_APP_NODE_ENV) {
		case 'development':
			return dev;
		case 'production':
			return prod;
		case 'test':
			return test;
		default:
			return dev;
	}
};

export const env = getEnv();
